"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PairUniswapV2 = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const IUniswapV2Pair_1 = require("../../types/web3-v1-contracts/IUniswapV2Pair");
const pair_1 = require("../pair");
const mainnet_PairUniswapV2_addr_json_1 = require("../../tools/deployed/mainnet.PairUniswapV2.addr.json");
const utils_1 = require("../utils");
const ERC20_1 = require("../../types/web3-v1-contracts/ERC20");
class PairUniswapV2 extends pair_1.PairXYeqK {
    constructor(chainId, web3, pairAddr, fixedFee = new bignumber_js_1.default(0.997), lp) {
        super((0, utils_1.selectAddress)(chainId, { mainnet: mainnet_PairUniswapV2_addr_json_1.address }));
        this.chainId = chainId;
        this.web3 = web3;
        this.pairAddr = pairAddr;
        this.fixedFee = fixedFee;
        this.allowRepeats = false;
        this.decimals = [18, 18];
        this.lpToken = lp;
        this.pair = new this.web3.eth.Contract(IUniswapV2Pair_1.ABI, pairAddr);
        const feeKInv = new bignumber_js_1.default(1000).minus(this.fixedFee.multipliedBy(1000));
        if (!feeKInv.isInteger() || !feeKInv.gt(0) || !feeKInv.lt(100)) {
            throw new Error(`Invalid fixedFee: ${this.fixedFee}!`);
        }
        this.feeKData = feeKInv.toString(16).padStart(2, "0");
    }
    async _init() {
        const [tokenA, tokenB] = await Promise.all([
            this.pair.methods.token0().call(),
            this.pair.methods.token1().call(),
        ]);
        const tokenAContract = new this.web3.eth.Contract(ERC20_1.ABI, tokenA);
        const tokenBContract = new this.web3.eth.Contract(ERC20_1.ABI, tokenB);
        this.decimals = await Promise.all([
            tokenAContract.methods.decimals().call(),
            tokenBContract.methods.decimals().call(),
        ]);
        return {
            pairKey: this.pairAddr,
            tokenA,
            tokenB,
        };
    }
    async refresh() {
        if (!this.pair) {
            throw new Error(`not initialized!`);
        }
        const reserves = await this.pair.methods.getReserves().call();
        this.refreshBuckets(this.fixedFee, new bignumber_js_1.default(reserves[0]), new bignumber_js_1.default(reserves[1]));
    }
    swapExtraData() {
        return `${this.pair.options.address}${this.feeKData}`;
    }
    depositExtraData() {
        return this.swapExtraData();
    }
    bootstrap({ reserves, ...rest }) {
        super.bootstrap({
            ...rest,
            bucketA: reserves[0],
            bucketB: reserves[1],
            fee: this.fixedFee.toFixed(),
        });
    }
    loadLpAddress() {
        this.lpToken = this.pairAddr;
        return new Promise((res) => res(true));
    }
    getDescriptor() {
        const TEN = new bignumber_js_1.default("10");
        const liquidityA = this.bucketA.div(TEN.pow(this.decimals[0]));
        const liquidityB = this.bucketB.div(TEN.pow(this.decimals[1]));
        const hide = liquidityA.isLessThanOrEqualTo("1000") &&
            liquidityB.isLessThanOrEqualTo("1000");
        return {
            ...super.getDescriptor(),
            _type: hide ? "general" : "uni-v2",
            poolAddress: this.pairAddr,
            lpToken: this.lpToken,
        };
    }
    getMulticallPayloadForBootstrap() {
        return [
            {
                fieldName: "reserves",
                targetInterface: utils_1.UniV2Interface,
                target: this.pairAddr,
                method: "getReserves",
                transformResult: (r) => [r[0].toString(), r[1].toString()],
            },
        ];
    }
}
exports.PairUniswapV2 = PairUniswapV2;
//# sourceMappingURL=uniswapv2.js.map